/**
 * @description
 * Behavior for menu divider
 *
 * @specification
 * Adds role 'presentation' to 'root' slot.
 */
export var menuDividerBehavior = function menuDividerBehavior() {
  return {
    attributes: {
      root: {
        role: 'presentation'
      }
    }
  };
};
//# sourceMappingURL=menuDividerBehavior.js.map
